
import React, { useState } from 'react';
import Modal from './modal';
import { useGlobalState } from '../Context';


const Info = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { state, dispatch } = useGlobalState();
    
    const openModal = () => {
      setIsModalOpen(true)

      dispatch({
        type: 'UPDATE_GLOBAL_PROPERTY',
        key: 'gallery_mode',
        value: true,
      });
    }
    const closeModal = () => {
      setIsModalOpen(false);

      dispatch({
        type: 'UPDATE_GLOBAL_PROPERTY',
        key: 'gallery_mode',
        value: false,
      });
    }

  return (
    <div className={state.gallery_mode? "info gallery_mode":"info"}>
        <h2>Event decoration company</h2>

        <button onClick={openModal} type="submit" style={{ maxWidth: '120px' }} className='contactFormSubmit'>Read more </button>
        
        <Modal isOpen={isModalOpen} onClose={closeModal}>
            <h2>Our terms</h2>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>

            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>

            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
        </Modal>
    </div>
  );
};


export default Info;